import FormChangeableMixin from 'mixins/FormChangeableMixin'
import FormFocusableMixin from 'mixins/FormFocusableMixin'

export default {
    mixins: [FormChangeableMixin, FormFocusableMixin],

    props: {
        valuePath: { type: String, required: true },
    },

    computed: {
        repeats() {
            const value = this.$get(this.formData, this.valuePath)
            return value && value.length ? value : [{}]
        },

        initialRepeats() {
            return 1
        },
    },

    methods: {
        createRepeat() {
            return {}
        },

        valuePathField(index, fieldValuePath) {
            return `${this.valuePath}.${index}.${fieldValuePath}`
        },

        addRepeat(count = 1) {
            this.change(this.repeats.concat(Array(count).fill(this.createRepeat())))
            this.focusAutofocusInput(this.repeats.length - 1)
        },

        changeRepeat(index, { path, value }) {
            const parts = path.split('.')
            this.$set(this.repeats[index], parts[parts.length - 1], value)
            this.change(this.repeats)
        },

        removeRepeat(index) {
            this.repeats.splice(index, 1)
            this.change(this.repeats)
            this.focusAutofocusInput(Math.max(0, index - 1))
        },
    },

    mounted() {
        if (this.repeats.length < this.initialRepeats) {
            this.addRepeat(this.initialRepeats)
        }
    },
}
